// extracted by mini-css-extract-plugin
module.exports = {"container":"abn8GAeSya8F1R5k_uVBX","flex":"_2wadDnOGDIvxDd5iRtjbV8","tab":"_3mKpYtXUeu0VM0Hm6RtCpT","selectedTab":"EceIz2FGb5w_S8-Pwaa5-"};